const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'];

/**
 * Formats a file size in bytes into a human readable string, e.g. 204800 -> "200 KB"
 * @param bytes - the file size in bytes
 * @returns the formatted string, or undefined if bytes is not a valid, non-negative number
 */
export const formatFileSize = (bytes: number | undefined | null): string | undefined => {
  if (typeof bytes !== 'number' || Number.isNaN(bytes) || bytes < 0) return undefined;
  if (bytes === 0) return `0 ${UNITS[0]}`;

  const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), UNITS.length - 1);
  const value = bytes / 1024 ** exponent;
  // round to 1 decimal place under 10 units, otherwise a whole number - Number() drops any insignificant
  // trailing zero (e.g. 5.0 -> 5) so whole values don't show a redundant decimal
  const rounded = exponent === 0 ? value : Number(value.toFixed(value < 10 ? 1 : 0));

  return `${rounded} ${UNITS[exponent]}`;
};
